import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import moment from 'moment';
import 'moment/locale/ru';
import 'typeface-inter';
import { ConfigProvider } from 'antd';
import 'mobx-react-lite/batchingForReactDom';
import { YMaps } from 'react-yandex-maps';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import ru from 'antd/es/locale/ru_RU';

import Auth from 'models/auth';
import RootRouter from './rootRouter';

import 'themes/style.scss';

moment.locale('ru');

const auth = new Auth();

Sentry.init({
  dsn: 'https://ace4cdcf28e9444b830953643b28c53e@o4504033821130752.ingest.sentry.io/4504264160247808',
  integrations: [new BrowserTracing()],

  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <ConfigProvider locale={ru}>
    <Provider auth={auth}>
      <YMaps>
        <RootRouter />
      </YMaps>
    </Provider>
  </ConfigProvider>,
  document.getElementById('root'),
);
